package one.healthium.onboarding.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.stack.StackNavigation
import com.arkivanov.decompose.router.stack.active
import com.arkivanov.decompose.router.stack.childStack
import com.arkivanov.decompose.router.stack.childStackWebNavigation
import com.arkivanov.decompose.router.stack.pop
import com.arkivanov.decompose.router.stack.pushNew
import com.arkivanov.decompose.router.webhistory.WebNavigation
import com.arkivanov.decompose.value.Value
import kotlinx.serialization.Serializable
import one.healthium.base.preferences.AppPreferences
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.domain.paywall.models.PaywallSet
import one.healthium.onboarding.domain.OnboardingModel
import one.healthium.onboarding.domain.screens.ScreensGroupModel
import one.healthium.onboarding.navigation.screenDefinition.DefaultScreenGroupComponent

class DefaultOnboardingComponent(
    componentContext: ComponentContext,
    private val appPreferences: AppPreferences,
    override val model: OnboardingModel,
    override val paywallSet: PaywallSet?,
    private val onSignInClicked: () -> Unit,
    private val onFinished: () -> Unit,
) : OnboardingComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {

    private val nav = StackNavigation<Config>()

    private val _stack = childStack(
        source = nav,
        serializer = Config.serializer(),
        initialStack = {
            listOf(Config(screenGroup = model.screens.first()))
        },
        childFactory = ::child,
        handleBackButton = true,
    )

    private fun child(config: Config, componentContext: ComponentContext): OnboardingComponent.ScreenGroupChild {
        return OnboardingComponent.ScreenGroupChild(
            DefaultScreenGroupComponent(
                componentContext = componentContext,
                screenGroup = config.screenGroup,
                onFinished = this::pushNextGroup,
                onSignInClicked = onSignInClicked,
            )
        )
    }

    override val stack: Value<ChildStack<*, OnboardingComponent.ScreenGroupChild>> = _stack

    override val webNavigation: WebNavigation<*> =
        childStackWebNavigation(
            navigator = nav,
            stack = _stack,
            serializer = Config.serializer(),
            childSelector = { it.instance.component }
        )

    override fun onBackClicked() {
        nav.pop()
    }

    private fun pushNextGroup() {
        val index = model.screens.indexOf(stack.active.instance.component.screenGroup)
        if (index > -1 && index + 1 < model.screens.size) {
            nav.pushNew(Config(model.screens[index + 1]))
        } else {
            appPreferences.onboardingPassed = true
            onFinished()
        }
    }

    @Serializable
    private data class Config(
        val screenGroup: ScreensGroupModel
    )
}